/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs */



/**
* | output |
* | --- |
* | "Leading & Trailing Spaces" |
*
* @param {Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_leading_trailing_spaces_label = /** @type {((inputs?: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espaces de debut et de fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorder- und Rückräume")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazi iniziali e finali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ведущие и следующие зоны")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacios iniciales y finales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("首尾空格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("先頭と末尾のスペース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अग्रणी और अनुगामी स्थान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaços de liderança e de seguimento")
	return /** @type {LocalizedString} */ ("Leading & Trailing Spaces")
});